import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Step from '@material-ui/core/Step';
import Typography from '@material-ui/core/Typography';
import MuiStepper from '@material-ui/core/Stepper';
import StepButton from '@material-ui/core/StepButton';
import withStyles from '@material-ui/core/styles/withStyles';
import StepConnector from '@material-ui/core/StepConnector';
import { useMediaQuery } from '@material-ui/core';
import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  content: {
    margin: '15px 0',
    width: '100%',
  },
  alternativeLabel: {
    width: '25%',
  },
  viewedAlternativeLabel: {
    width: '25%',
    '& .MuiStepConnector-line': {
      backgroundColor: colors.darkBlue,
      opacity: 0.9,
    },
  },
  iconContainer: {
    '& .MuiStepIcon-root': {
      color: colors.blue,
      zIndex: 1,
    },
    '& .MuiStepLabel-label': {
      color: colors.title,
      '&:hover': {
        color: colors.blue,
      },
    },
  },
  viewedIconContainer: {
    '& .MuiStepIcon-root': {
      color: colors.darkBlue,
      zIndex: 1,
      '&.MuiStepIcon-active': {
        color: colors.darkBlue,
      },
    },
    '& .MuiStepLabel-label': {
      color: colors.title,
      '&.MuiStepLabel-active': {
        fontWeight: 'bold',
      },
      '&:hover': {
        color: colors.blue,
      },
    },
  },
}));

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 7,
    left: '-50%',
    right: '50%',
  },
  line: {
    height: 11,
    backgroundColor: colors.blue,
    opacity: 0.5,
    border: 'none',
  },
})(StepConnector);

const Stepper = ({ className, steps, currentStep, disabled }) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.down('xs'));

  const [activeStepNumber, setActiveStepNumber] = React.useState(currentStep);
  const [activeStep, setActiveStep] = React.useState(steps[currentStep]);

  React.useEffect(() => {
    setActiveStepNumber(currentStep);
    setActiveStep(steps[currentStep]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep]);

  return (
    <div className={className}>
      <MuiStepper activeStep={activeStepNumber} alternativeLabel connector={<QontoConnector />} nonLinear>
        {steps.map((step, index) => (
          <Step
            key={step.label}
            classes={{
              alternativeLabel: index <= activeStepNumber ? classes.viewedAlternativeLabel : classes.alternativeLabel,
            }}
          >
            <StepButton
              disabled={disabled}
              onClick={() => step.handleStep(index + 1)}
              classes={{ root: index <= activeStepNumber ? classes.viewedIconContainer : classes.iconContainer }}
            >
              {/* eslint-disable-next-line no-nested-ternary */}
              {mobileView ? (index === activeStepNumber ? step.label : '') : step.label}
            </StepButton>
          </Step>
        ))}
      </MuiStepper>
      <div>
        {activeStepNumber === steps.length ? (
          <div>
            {/* TODO clarify if we need it */}
            <Typography className={classes.instructions}>All steps completed</Typography>
          </div>
        ) : (
          <div className={classes.content}>{activeStep?.content}</div>
        )}
      </div>
    </div>
  );
};

Stepper.propTypes = {
  className: PropTypes.string,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
      content: PropTypes.node,
      info: PropTypes.node,
      nextStepAction: PropTypes.func,
      backStepAction: PropTypes.func,
    }),
  ).isRequired,
  currentStep: PropTypes.number,
  disabled: PropTypes.bool,
};

Stepper.defaultProps = {
  currentStep: 0,
  disabled: false,
};

export default memo(Stepper);
